module.exports = __webpack_public_path__ + "static/media/IMG_9108.2c47da2f.mp4";